export default "__VITE_ASSET__73495123__"